import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';
import { TextImageType } from 'store/reducers/visualisations/types';

export const typeOptions: SettingsRadioItem<TextImageType>[] = [
  { value: 'fromDatabase', label: 'База данных' },
  { value: 'link', label: 'Ссылка' },
];
